
<template>
  <button
    :disabled="disabled"
    :type="type"
    class="inline-flex items-center justify-center rounded-md border focus:outline-none disabled:cursor-not-allowed disabled:opacity-50"
    :class="[buttonType, buttonSize, iconColor, extraClass]"
  >
    <img
      v-if="imagePath"
      :src="cdn(imagePath)"
      :class="[iconSize ? iconSize : buttonImageSize]"
      alt=""
    >
    <component
      :is="iconName"
      v-if="iconName"
      :class="[iconSize ? iconSize : buttonImageSize, iconExtraClass]"
    />
    <slot name="extra-content" />
  </button>
</template>

<script setup>
import { onMounted, ref } from 'vue';

const props = defineProps({
  extraClass: {
    type: String,
    default: '',
  },
  iconSize: {
    type: String,
    default: ''
  },
  btnType: {
    type: String,
    default: 'secondary',
  },
  type: {
    type: String,
    default: 'button',
  },
  disabled: {
    type: Boolean,
    default: false
  },
  size: {
    type: String,
    default: 'btn-sm',
  },
  iconName: {
    type: String,
    default: ''
  },
  iconType: {
    type: String,
    required: true,
    default: 'outline'
  },
  iconColor: {
    type: String,
    required: true,
    default: ''
  },
  imagePath: {
    type: String,
    required: true,
    default: ''
  },
  iconExtraClass: {
    type: String,
    default: ''
  },
});

const buttonType = ref('');
const buttonSize = ref('');
const buttonImageSize = ref('');

onMounted(() => {
  switch (props.btnType) {
    case 'primary':
      buttonType.value = 'bg-primary-900 border-transparent text-white ';
      break;
    case 'secondary':
      buttonType.value = 'bg-secondary-800 transition-colors duration-200 ease-linear hover:bg-primary-310 text-white ';
      break;
    case 'danger':
      buttonType.value = 'bg-redCust-730 transition-colors duration-200 ease-linear hover:bg-pinkCust-150 text-white ';
      break;
    case 'gray-outline-btn':
      buttonType.value = 'text-grayCust-980 border-grayCust-160 hover:bg-grayCust-50 hover:text-grayCust-1740 transition-colors duration-200 ease-linear focus:bg-grayCust-50';
      break;
    case 'danger-outline-btn':
      buttonType.value = 'text-redCust-730 border-redCust-220 hover:bg-redCust-110 hover:text-pinkCust-150 transition-colors duration-200 ease-linear focus:bg-redCust-110';
      break;
  }
  switch (props.size) {
    case 'btn-sm':
      buttonSize.value = 'h-[32px] min-w-[32px]';
      buttonImageSize.value = 'w-4 h-4';
      break;
    case 'btn-md':
      buttonSize.value = 'h-[34px] min-w-[34px]';
      buttonImageSize.value = 'w-4 h-4';
      break;
    case 'btn-lg':
      buttonSize.value = 'h-[36px] min-w-[36px]';
      buttonImageSize.value = 'w-5 h-5';
      break;
    case 'btn-xl':
      buttonSize.value = 'h-[40px] min-w-[40px]';
      buttonImageSize.value = 'w-5 h-5';
      break;
    case 'btn-xxl':
      buttonSize.value = 'h-[46px] min-w-[46px]';
      buttonImageSize.value = 'w-6 h-6';
      break;
  }
});

</script>
